import Icon from '../components/Icon.vue'

Icon.register({"level-down-alt":{"width":320,"height":512,"paths":[{"d":"M313.6 392.3L209.6 504.3C200.1 514.5 183.9 514.6 174.4 504.3L70.4 392.3C56.2 377 67.1 352 88 352H152V80H68A12-12 0 0 0 59.5 76.5L3.5 20.5C-4 12.9 1.3 0 12 0H208C221.3 0 232 10.7 232 24V352H296C316.8 352 327.8 377 313.6 392.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/level-down-alt.js
// module id = null
// module chunks = 